import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './wwex-clear-all-link.messages';

type WwexClearAllLinkProps = {
  isDisabled?: boolean;
  onClick: () => void;
};

export const WwexClearAllLink = ({ isDisabled = false, onClick }: WwexClearAllLinkProps) => {
  const intl = useIntl();

  return (
    <Button disabled={isDisabled} onClick={onClick} theme={THEME_CONSTANTS.link}>
      {intl.formatMessage(messages.clearAllLabel)}
    </Button>
  );
};
